import axios from 'axios';

import {
    debug,
    uploadHost
} from "@/config";

/**
 * 获取项目列表
 * @param page
 * @param limit
 * @returns {Promise<unknown>}
 */
const getProjectsList = function (page, limit) {
    return new Promise((resolve, reject) => {
        axios.get(
            uploadHost + "/api/v1/projects?page=" + page + "&limit=" + limit,
            {
                headers: {
                    'Content-Type': 'application/json',
                    // 'Access-Control-Allow-Origin': '*'
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 获取所有已发射代币的项目（支持分页）
 * @param page
 * @param limit
 * @returns {Promise<unknown>}
 */
const getProjectsLaunchedList = function (page, limit) {
    return new Promise((resolve, reject) => {
        axios.get(
            uploadHost + "/api/v1/projects/launched?page=" + page + "&limit=" + limit,
            {
                headers: {
                    'Content-Type': 'application/json',
                    // 'Access-Control-Allow-Origin': '*'
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 获取所有已结束的项目（支持分页）
 * @param page
 * @param limit
 * @returns {Promise<unknown>}
 */
const getProjectsEndedList = function (page, limit) {
    return new Promise((resolve, reject) => {
        axios.get(
            uploadHost + "/api/v1/projects/ended?page=" + page + "&limit=" + limit,
            {
                headers: {
                    'Content-Type': 'application/json',
                    // 'Access-Control-Allow-Origin': '*'
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 获取所有进行中的项目
 * @returns {Promise<unknown>}
 */
const getActiveProjectsAll = function () {
    return new Promise((resolve, reject) => {
        axios.get(
            uploadHost + "/api/v1/projects/active",
            {
                headers: {
                    'Content-Type': 'application/json',
                    // 'Access-Control-Allow-Origin': '*'
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 获取项目详情
 * @param projectId
 * @returns {Promise<unknown>}
 */
const getProjectInfo = function (projectId) {
    return new Promise((resolve, reject) => {
        axios.get(
            uploadHost + "/api/v1/project/" + projectId + "/bidding",
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 获取项目的竞价历史
 * @param projectId
 * @returns {Promise<unknown>}
 */
const getProjectHistory = function (projectId) {
    return new Promise((resolve, reject) => {
        axios.get(
            uploadHost + "/api/v1/project/" + projectId + "/history",
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 获取项目的所有媒体文件
 * @param projectId
 * @returns {Promise<unknown>}
 */
const getProjectFiles = function (projectId) {
    return new Promise((resolve, reject) => {
        axios.get(
            uploadHost + "/api/v1/project/" + projectId + "/files",
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 获取我购买的项目列表
 * @param account
 * @returns {Promise<unknown>}
 */
const getMyProjectList = function (account) {
    return new Promise((resolve, reject) => {
        axios.get(
            uploadHost + "/api/v1/user/" + account + "/holdings",
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 获取用户的竞价历史
 * @param account
 * @returns {Promise<unknown>}
 */
const getMyProjectBiddingHistory = function (account) {
    return new Promise((resolve, reject) => {
        axios.get(
            uploadHost + "/api/v1/user/" + account + "/bidding-history",
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 获取项目的代币部署信息
 * @param projectId
 * @returns {Promise<unknown>}
 */
const getArtlaunch = function (projectId) {
    return new Promise((resolve, reject) => {
        axios.get(
            uploadHost + "/api/v1/project/" + projectId + "/artlaunch",
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 获取代币的完整信息（包含扩展信息）
 * @param token
 * @returns {Promise<unknown>}
 */
const getTokenArtlaunch = function (token) {
    return new Promise((resolve, reject) => {
        axios.get(
            uploadHost + "/api/v1/artlaunch/" + token,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 获取代币的24h成交量
 * @param tokenAddress
 * @returns {Promise<unknown>}
 */
const getFetch24hVolume = function (tokenAddress) {
    return new Promise((resolve, reject) => {
        axios.get(
            `https://api.pancakeswap.info/api/v2/tokens/${tokenAddress}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 更新代币的扩展信息（仅限首次设置）
 * @param token
 * @param description
 * @param website
 * @param telegram
 * @param twitter
 * @returns {Promise<unknown>}
 */
const commitArtlaunchInfo = function (token, description, website, telegram, twitter) {
    return new Promise((resolve, reject) => {
        axios.post(
            uploadHost + "/api/v1/artlaunch/" + token + "/info",
            {
                description: description,
                website: website,
                telegram: telegram,
                twitter: twitter
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 创建项目信息
 * @param projectId
 * @param name
 * @param description
 * @returns {Promise<unknown>}
 */
const createProjectInfo = function (projectId, name, description) {
    return new Promise((resolve, reject) => {
        axios.post(
            uploadHost + "/api/v1/project/" + projectId + "/info",
            {
                name: name,
                description: description
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * 计算 salt
 * @param name
 * @param symbol
 * @param targetSuffix
 * @returns {Promise<unknown>}
 */
const calculateSalt = function (name, symbol, targetSuffix) {
    return new Promise((resolve, reject) => {
        axios.post(
            uploadHost + "/api/v1/calculate-salt",
            {
                name: name,
                symbol: symbol,
                target_suffix: targetSuffix
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'json'
            }
        ).then(res => {
            let { data } = res;
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

const http = {
    getProjectsList,
    getProjectsLaunchedList,
    getProjectsEndedList,
    getActiveProjectsAll,
    getProjectInfo,
    getProjectHistory,
    getProjectFiles,
    getMyProjectList,
    getMyProjectBiddingHistory,
    getArtlaunch,
    getTokenArtlaunch,
    getFetch24hVolume,
    commitArtlaunchInfo,
    createProjectInfo,
    calculateSalt
}

export default http;
